import { render, staticRenderFns } from "./ModuleStart.vue?vue&type=template&id=2702b8bf&scoped=true&"
import script from "./ModuleStart.vue?vue&type=script&lang=js&"
export * from "./ModuleStart.vue?vue&type=script&lang=js&"
import style0 from "./ModuleStart.vue?vue&type=style&index=0&id=2702b8bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2702b8bf",
  null
  
)

export default component.exports